import { ethereum } from '@0xtorch/core'
import { soneium } from 'viem/chains'
import { type Client, createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createBlockscout } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

type CreateSoneiumChainParameters = {
  client: Client
  explorer: Explorer
}

export const createSoneiumChain = ({
  explorerProxyUrl: proxyUrl,
}: {
  explorerProxyUrl?: string
}): Chain =>
  createSoneiumChainCustom({
    client: createClient({
      chain: soneium,
      httpRpcs: soneiumHttpRpcs,
    }),
    explorer: createBlockscout({
      useAddressApiV2: true,
      name: 'Soneium Network explorer',
      baseUrl: 'https://soneium.blockscout.com',
      apiBaseUrl: 'https://soneium.blockscout.com/api',
      proxyUrl,
    }),
  })

export const createSoneiumChainCustom = ({
  client,
  explorer,
}: CreateSoneiumChainParameters): Chain => ({
  id: 1868,
  network: 'soneium',
  name: 'Soneium',
  nativeToken: {
    name: 'Ethereum',
    symbol: 'ETH',
    decimals: 18,
    currency: ethereum,
  },
  wrappedTokenAddresses: new Set([
    '0x4200000000000000000000000000000000000006',
  ]),
  explorer,
  client,
  blockTime: 2000,
  coingeckoId: 'soneium',
  defillamaId: undefined,
})

export const soneiumHttpRpcs: HttpRpc[] = [
  {
    url: 'https://rpc.soneium.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://soneium.gateway.tenderly.co',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://1868.rpc.thirdweb.com',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
]

export const soneiumWebsocketRpcUrls: readonly string[] = []
